import type { ConsentStrategy } from './ConsentStrategy';

declare global {
  interface Window {
    /** Integrator escape hatch: forces consent on/off ahead of every CMP and cookie check. */
    bvTrackingConsent?: boolean;
  }
}

/**
 * Highest priority, so exotic setups can be wired up without a new strategy class.
 * Only an actual boolean counts as "set" — a stray truthy string must not enable tracking.
 */
export class OverrideStrategy implements ConsentStrategy {
  readonly name = 'override';

  isPresent(): boolean {
    return typeof window.bvTrackingConsent === 'boolean';
  }

  hasConsent(): boolean {
    return window.bvTrackingConsent === true;
  }
}
